module.exports = __webpack_public_path__ + "static/media/14.f0e4b272.png";